import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import TwitterIcon from "../../../UI/TwitterIcon";
import InstagramIcon from "../../../UI/InstagramIcon";
import FacebookIcon from "../../../UI/FacebookIcon";
import LinkedinIcon from "../../../UI/LinkedinIcon";
import PrinterestIcon from "../../../UI/PrinterestIcon";
const socialButtons = [
  { icon: TwitterIcon },
  { icon: InstagramIcon },
  { icon: FacebookIcon },
  { icon: LinkedinIcon },
  { icon: PrinterestIcon },
];
const jobsData = [
  {
    title: "Jobs",
    linksTitle: [
      { title: "IT Development" },
      { title: "Finance" },
      { title: "Healthcare" },
      { title: "Sales & Marketing" },
      { title: "Education" },
      { title: "Design" },
      { title: "Research" },
      { title: "Human Resources" },
      { title: "Freelance" },
      { title: "Jobs For You" },
    ],
  },
];
const companyLinksData = [
  [
    {
      title: "About",
      linksTitle: [
        { title: "About Us" },
        { title: "History" },
        { title: "Our Team" },
        { title: "Testimonials" },
      ],
    },
  ],
  [
    {
      title: "Services",
      linksTitle: [
        { title: "For Employee" },
        { title: "For Employer" },
        { title: "Support" },
      ],
    },
  ],
  [
    {
      title: "Blog",
      linksTitle: [{ title: "News" }, { title: "Tips" }, { title: "Events" }],
    },
  ],
  [
    {
      title: "Contact",
      linksTitle: [
        { title: "Phone" },
        { title: "Email" },
        { title: "Social Media" },
      ],
    },
  ],
];

function FooterSection() {
  return (
    <Stack sx={{ bgcolor: "#000000", p: "110px" }}>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", gap: "100px" }}
      >
        <Stack
          id="stay-updated"
          direction="column"
          sx={{
            alignSelf: "start",
            height: "100%",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "54px",
              lineHeight: "62px",
              color: "  #FFFFFF",
              fontFamily: "Inter",
              fontWeight: "700",
            }}
          >
            Stay Updated
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "18px",
              lineHeight: "22px",
              color: "  #bfbfbf",
              fontFamily: "Inter",
              fontWeight: "400",
              maxWidth: "460px",
              py: "10px",
            }}
          >
            Stay up-to-date with the latest job listings and career tips from
            our newsletter.
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Enter Email Address ..."
            sx={{
              my: "30px",
              minWidth: "650px",
              input: {
                color: "  #bfbfbf",
                fontSize: "20px",
                "&::placeholder": {
                  color: "  #bfbfbf",
                  opacity: 0.9,
                },
              },
              "& .MuiOutlinedInput-root": {
                py: "3px",
                borderRadius: "52px",
                pl: "10px",
                pr: "8px",
                "& fieldset": { border: "1px solid #FDDF59" }, // Outline color
                "&:hover fieldset": {
                  border: "1px solid #FDDF59",
                }, // Hover state
                "&.Mui-focused fieldset": {
                  border: "1px solid #FDDF59",
                }, // Focus state
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="top">
                  <Button
                    sx={{
                      color: "black",
                      backgroundColor: "#FDDF59",
                      fontSize: "20px",
                      borderRadius: "52px",
                      fontFamily: "Inter",
                      fontWeight: "700",
                      px: "28px",
                      py: "10px",
                      textTransform: "none",
                    }}
                    variant="contained"
                  >
                    Subscribe
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              mt: "52px",
            }}
          >
            {" "}
            <Stack id="pitchers-logo-name" direction="row" sx={{ gap: "18px" }}>
              <Box
                component="img"
                src="/images/pitchers.png"
                sx={{ width: "40px", height: "36px", borderRadius: "6px" }}
              ></Box>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "32px",
                  lineHeight: "36px",
                  color: "  #FFFFFF",
                  fontFamily: "Inter",
                  fontWeight: "700",
                }}
              >
                Pitchers
              </Typography>
            </Stack>
            <Stack direction="row" id="social-icons" sx={{ gap: "14px" }}>
              {socialButtons.map((social) => (
                <IconButton sx={{ p: "0px" }}>{<social.icon />}</IconButton>
              ))}
            </Stack>
          </Box>
        </Stack>
        <Stack
          direction="row"
          id="jobs-about-services-blog-contact"
          sx={{ gap: "100px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              minWidth: "180px",
            }}
          >
            {jobsData.map((job) => (
              <>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "36px",
                    color: "#ffffff",
                    fontFamily: "Inter",
                    fontWeight: "700",
                  }}
                >
                  {job.title}
                </Typography>
                {job.linksTitle.map((link) => (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "18px",
                      lineHeight: "22px",
                      color: "  #bfbfbf",
                      fontFamily: "Inter",
                      fontWeight: "400",
                    }}
                  >
                    {link.title}
                  </Typography>
                ))}
              </>
            ))}
          </Box>
          <Stack direction="row" sx={{ flexWrap: "wrap", gap: "50px" }}>
            {companyLinksData.map((company) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  minWidth: "150px",
                }}
              >
                {company.map((job) => (
                  <>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "36px",
                        color: "#ffffff",
                        fontFamily: "Inter",
                        fontWeight: "700",
                      }}
                    >
                      {job.title}
                    </Typography>
                    {job.linksTitle.map((link) => (
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "18px",
                          lineHeight: "22px",
                          color: "  #bfbfbf",
                          fontFamily: "Inter",
                          fontWeight: "400",
                        }}
                      >
                        {link.title}
                      </Typography>
                    ))}
                  </>
                ))}
              </Box>
            ))}
          </Stack>
        </Stack>
      </Stack>
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#808080",
          mt: "60px",
          mb: "20px",
          border: "none",
        }}
      />
      <Stack id="Copyright @" direction="row" justifyContent="space-between">
        <Typography
          variant="body2"
          sx={{
            color: "#808080",
            fontSize: "20px",
            fontWeight: "400",
            lineHeight: "30px",
            fontFamily: "Inter",
          }}
        >
          Copyright &copy; 2025 By Pitchers. All rights reserved.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#808080",
            fontSize: "20px",
            fontWeight: "400",
            lineHeight: "30px",
            fontFamily: "Inter",
          }}
        >
          Privacy Policy. Terms & Condition.
        </Typography>
      </Stack>
    </Stack>
  );
}

export default FooterSection;
